import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import apiClient from "../api.js";
import {
  signInStart,
  signInSuccess,
  signInFailure,
} from "../redux/user/userSlice";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { loading, error } = useSelector((state) => state.user);

  const notify = () => toast("Password or Username Incorrect");
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      dispatch(signInStart());
      const res = await apiClient.post("auth/signin", formData);

      // const data = await res.json();

      if (res.data) {
        // localStorage.setItem("auth", JSON.stringify(res.data));
        dispatch(signInSuccess(res.data));
        navigate("/");
        // console.log(res.data);
      }
    } catch (error) {
      notify();
      dispatch(signInFailure(error.message));
    }
  };

  return (
    <>
      <section className="sign-up-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="sign-up-div">
                <h1 className="sign-up-txt mt-3">Sign In</h1>
                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    className="usernameinput mt-3"
                    placeholder="Email"
                    id="email"
                    onChange={handleChange}
                  />
                  <input
                    type="password"
                    className="usernameinput mt-3"
                    placeholder="Password"
                    id="password"
                    onChange={handleChange}
                  />
                  <button className="sing-up-btn mt-3">SIGN IN</button>
                </form>
                <p className="have-account-txt mt-3">
                  Dont Have an account? <Link to="/sign-up">Sign Up</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
    </>
  );
};

export default SignIn;
